import ThreeDSAnswerForm from './ThreeDSAnswerForm';

export default ThreeDSAnswerForm;